export class OptionPage {
  active = false;
  pageItems: any[];
  index: number;
}
